import { Address, JsonAddress } from './address'
import { JsonModel, Model } from './model'

/**
 * Lightweight supplier used within record rows.
 *
 * Mirrors the backend `SupplierResourceRecordContext`, which only exposes the
 * fields needed to render a record (id, name) plus an optional physical address
 * for views that require it (e.g. the invalid supplier page).
 */
export class RecordSupplier extends Model {
    name: string
    physicalAddress: Address | null

    constructor(json: JsonRecordSupplier) {
        super(json)

        this.name = json.name
        this.physicalAddress = json.physicalAddress
            ? new Address(json.physicalAddress)
            : null
    }
}

export interface JsonRecordSupplier extends JsonModel {
    name: string
    physicalAddress?: JsonAddress | null
}
